import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// action creators
import { doneIndicator } from 'store/actions/httpActions';

// api
import client from 'sources/api';

// constants
import {
  MILESTONE_FETCH_REQUEST,
  MILESTONE_FETCH,
} from 'store/constants/milestoneTypes';

// schemas
import { milestoneSchema } from 'store/schemas/milestoneSchema';

// helpers
import httpSaga from 'store/sagas/httpSaga';

const WATCH_TYPE = MILESTONE_FETCH_REQUEST;
const TYPE = MILESTONE_FETCH;

export function* fetchMilestones(action: any) {
  const {
    payload: { groupId },
  } = action;

  // @ts-expect-error ts-migrate(2569) FIXME: Type 'Generator<any, any, unknown>' is not an arra... Remove this comment to see the full error message
  yield* httpSaga(
    TYPE,
    call(client.get, `/tags?group_id=${groupId}&type=event`),
    {
      schema: [milestoneSchema],
    }
  );

  yield put(doneIndicator(TYPE));
}

export function* watch() {
  yield takeEvery(WATCH_TYPE, fetchMilestones);
}

export default function* root() {
  yield all([fork(watch)]);
}
